import { render, staticRenderFns } from "./bankinfo.vue?vue&type=template&id=006e6cd5&scoped=true&"
import script from "./bankinfo.vue?vue&type=script&lang=js&"
export * from "./bankinfo.vue?vue&type=script&lang=js&"
import style0 from "./bankinfo.vue?vue&type=style&index=0&id=006e6cd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e6cd5",
  null
  
)

export default component.exports